import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/home/block2-进入.png")